import { RpcObservableRequestContext } from '../rpc-observable-request';
import { RpcObservableResultContext } from '../rpc-observable-result';

/**
 * RPC Copilot request name and version.
 */
export class RpcObservableCopilotKey {
    public static command = 'CopilotObservable';
    public static configCommand = 'CopilotConfigObservable';
    public static version = '0.0.1';
}

/**
 * RPC observable copilot request type.
 */
export enum RpcObservableCopilotRequestType {
    RouteNavigation,
    ThemeChange,
    ToolChange,
    ActiveNodeNameChange,
    RequestRouteNavigation,
    RequestActiveNodeName,
    RequestThemeChange,
    RequestToolChange,
    RequestToSendToShellSendingPromptToCopilot,
    RequestToSendToExtensionSendingCopilotResponse
}

/**
 * The tool data for sending to extension.
 */
export interface RpcObservableCopilotShellToolData {
    name: string;
    displayName: string;
}
/**
 * Rpc observable copilot request data.
 */
export interface RpcObservableCopilotRequest extends RpcObservableRequestContext {
    type?: RpcObservableCopilotRequestType;
    errorMessage?: string;
    routeNavigation?: {
        url: string;
        target?: string;
    };
    themeChange?: {
        current: string;
        previous?: string;
    };
    toolChange?: RpcObservableCopilotShellToolData;
    activeNodeName?: string;
    copilotChatRequest?: RpcObservableCopilotChatRequestData;
    copilotChatResponse?: RpcObservableCopilotChatResponseData;
}

/**
 * Rpc observable copilot chat request data.
 */
export interface RpcObservableCopilotChatRequestData {
    prompt?: string;
    originExtension?: string;
}

/**
 * Rpc observable copilot chat response data.
 */
export interface RpcObservableCopilotChatResponseData {
    response?: string;
    targetExtension?: string;
}

/**
 * Rpc observable copilot result.
 */
export interface RpcObservableCopilotResult extends RpcObservableResultContext {
    message: string;
}

/**
 * Rpc observable copilot error.
 */
export interface RpcObservableCopilotError extends RpcObservableCopilotResult {
    error: Error;
}

/**
 * Rpc observable copilot request set data.
 */
export interface RpcObservableCopilotConfigRequest extends RpcObservableCopilotRequest, RpcObservableRequestContext {
}
